import SearchBar from '../../../../../../../../components/search-bar/SearchBar';
import { useCertificateTasksTableQueryParams } from '../../../../../../../../hooks/useCertificateTasksTableQueryParams';

const CertificateTasksTableHeader = (): JSX.Element => {
  const { setParams, filters } = useCertificateTasksTableQueryParams();

  const onSearchChange = (value: string): void => {
    setParams({ search: value, page: 1 });
  };

  return (
    <div className='flex justify-content-end align-items-center flex-wrap gap-2'>
      <SearchBar onSearchChange={onSearchChange} initialValue={filters.search} />
    </div>
  );
};

export default CertificateTasksTableHeader;
